"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useMemo, useRef } from "react"

declare global {
    interface Window {
        Termly?: {
            initialize: () => void
        }
    }
}

const SCRIPT_SRC_BASE = "https://app.termly.io"

interface Props {
    autoBlock?: boolean
    masterConsentsOrigin?: string
    websiteUUID: string
}

export default function Termly({ autoBlock, masterConsentsOrigin, websiteUUID }: Props) {
    const scriptSrc = useMemo(() => {
        const src = new URL(SCRIPT_SRC_BASE)
        src.pathname = `/resource-blocker/${websiteUUID}`
        if (autoBlock) {
            src.searchParams.set("autoBlock", "on")
        }
        if (masterConsentsOrigin) {
            src.searchParams.set("masterConsentsOrigin", masterConsentsOrigin)
        }
        return src.toString()
    }, [autoBlock, masterConsentsOrigin, websiteUUID])

    const isScriptAdded = useRef(false)

    useEffect(() => {
        if (isScriptAdded.current) return
        const script = document.createElement("script")
        script.src = scriptSrc
        document.head.appendChild(script)
        isScriptAdded.current = true
    }, [scriptSrc])

    const pathname = usePathname()
    const searchParams = useSearchParams()

    useEffect(() => {
        if (typeof window === "undefined") return

        if (window.Termly) {
            console.log("Termly is defined")
            if (typeof window.Termly.initialize === "function") {
                console.log("Termly.initialize being called")
                window.Termly.initialize()
            } else {
                console.log("Termly.initialize is not defined", window.Termly.initialize)
            }
        } else {
            console.log("Termly is not defined")
        }
    }, [pathname, searchParams])

    return null
}
